import { toast } from "react-toastify";
import AxiosInstance from "../api/api";

export const getContactLinks = () =>
  AxiosInstance.get(`/api/v1/connect`)
    .then((res) => {
      return res.data;
    })
    .catch((e) => toast.error(`${e?.response?.data?.message || e?.message}`));

export const postContactLinks = (data) =>
  AxiosInstance.post(`/api/v1/connect`, data)
    .then((res) => {
      return res.data;
    })
    .catch((e) => toast.error(`${e?.response?.data?.message || e?.message}`));

export const updateContact = (id, data) =>
  AxiosInstance.put(`/api/v1/connect/${id}`, data)
    .then((res) => {
      return res.data;
    })
    .catch((e) => toast.error(`${e?.response?.data?.message || e?.message}`));

export const deleteContact = (id, token) =>
  AxiosInstance.delete(`/api/v1/connect/${id}`)
    .then((res) => {
      return res.data;
    })
    .catch((e) => toast.error(`${e?.response?.data?.message || e?.message}`));
